<script setup>
import { computed } from "vue";

const props = defineProps({
  editor: {
    type: Object,
    required: true
  }
});

const pageProps = computed(() => props.editor.props);
const bgEffect = computed(() => {
  if (pageProps.value.bgEffect === "brighten") {
    return "bg-white/35";
  }

  if (pageProps.value.bgEffect === "darken") {
    return "bg-black/35";
  }

  if (pageProps.value.bgEffect === "blur") {
    return "backdrop-blur-lg";
  }

  return "";
});
</script>

<template>
  <div class="campaign-container-frame background">
    <div :class="bgEffect" class="bg-effect user-select-none pointer-events-none absolute inset-0 select-none"></div>
    <!--end::bf-effect-->

    <slot />
    <!--end::slot-->
  </div>
</template>
